module.exports = __webpack_public_path__ + "static/img/Brent.Stanton.08b6608.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brent.Stanton.jpg
// module id = MiUm
// module chunks = 0